import React, { useMemo, useState } from "react";
import { Table, Input, Alert } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useReportsStore } from '../../store/slices/createReportsSlice';

const { Search } = Input;

export default function InstallmentTable() {

  const reports = useReportsStore();
  const [filterText, setFilterText] = useState("");
  const installments = useMemo(
    () => reports.installment.data?.Installments || [],
    [reports.installment.data]
  );
  const currentFilter = useMemo(
    () => reports.installment.filter || {},
    [reports.installment.filter]
  );

  const totalCount = reports.installment.data?.TotalCount || 0;
  const loading = reports.installment.loading;
  const error = reports.installment.error;

  const totalsByUser = useMemo(() => {
    return installments.reduce((map, item) => {
      const key = item.ApplicantUsername || String(item.ApplicantUserId || item.Id || '');
      const amount = item.PayableAmount ?? item.Price ?? 0;
      if (!map[key]) {
        map[key] = { count: 0, amount: 0 };
      }
      map[key].count += 1;
      map[key].amount += amount;
      return map;
    }, {});
  }, [installments]);

  const dataSource = useMemo(() => {
    const query = filterText.trim().toLowerCase();
    if (!query) return installments;

    return installments.filter(item => {
      return [
        item.ApplicantUsername,
        item.ApplicantFullName,
        item.ApplicantMobileNumber,
        item.PolicyOwnerFullName,
        item.PolicyOwnerMobileNumber,
        item.BranchTitle,
        item.InstallmentTitle,
        item.InstallmentTermsTitle,
        item.StatusTitle,
      ].some(value => value && value.toString().toLowerCase().includes(query));
    });
  }, [filterText, installments]);

const handleTableChange = (pagination) => {
  reports.getInstallmentInfo({
    param: {
      ...currentFilter,
      pageIndex: pagination.current - 1,
      pageSize: pagination.pageSize,
    }
  });
};

  const columns = [
    // {
    //   title: "شناسه درخواست بیمه",
    //   dataIndex: "InsInsuranceRequestId",
    //   key: "InsInsuranceRequestId",
    //   width: 140,
    // },
    // {
    //   title: "شناسه قسط",
    //   dataIndex: "Id",
    //   key: "Id",
    //   width: 100,
    // },
    {
      title: "نام کاربری",
      dataIndex: "ApplicantUsername",
      key: "ApplicantUsername",
      width: 120,
      sorter: (a, b) => (a.ApplicantUsername || "").localeCompare(b.ApplicantUsername || ""),
      render: text => text && strings.getFarsiNum(text),
    },
    // {
    //   title: "شناسه کاربر",
    //   dataIndex: "ApplicantUserId",
    //   key: "ApplicantUserId",
    //   width: 120,
    //   render: value => value != null ? strings.getFarsiNum(String(value)) : '-',
    // },
    {
      title: "نام بیمه‌گذار",
      dataIndex: "ApplicantFullName",
      key: "ApplicantFullName",
      width: 180,
    },
    {
      title: "موبایل بیمه‌گذار",
      dataIndex: "ApplicantMobileNumber",
      key: "ApplicantMobileNumber",
      width: 120,
    },
    {
      title: "نام مالک بیمه‌نامه",
      dataIndex: "PolicyOwnerFullName",
      key: "PolicyOwnerFullName",
      width: 180,
    },
    {
      title: "موبایل مالک بیمه‌نامه",
      dataIndex: "PolicyOwnerMobileNumber",
      key: "PolicyOwnerMobileNumber",
      width: 120,
    },
    {
      title: "رشته بیمه",
      dataIndex: "BranchTitle",
      key: "BranchTitle",
      width: 140,
    },
    // {
    //   title: "شناسه رشته",
    //   dataIndex: "BranchId",
    //   key: "BranchId",
    //   width: 120,
    //   render: value => value != null ? strings.getFarsiNum(String(value)) : '-',
    // },
    // {
    //   title: "عنوان قسط",
    //   dataIndex: "InstallmentTitle",
    //   key: "InstallmentTitle",
    //   width: 220,
    // },
    {
      title: "عنوان شرایط قسط",
      dataIndex: "InstallmentTermsTitle",
      key: "InstallmentTermsTitle",
      width: 180,
    },
    {
      title: "روزهای قسط",
      dataIndex: "InstallmentDays",
      key: "InstallmentDays",
      width: 100,
    },
    // {
    //   title: "درصد قسط",
    //   dataIndex: "InstallmentPercent",
    //   key: "InstallmentPercent",
    //   width: 120,
    // },
    {
      title: "مبلغ قسط",
      dataIndex: "Price",
      key: "Price",
      width: 150,
      render: value => value != null ? `${strings.currencyFormat(value)} ریال` : '-',
    },
    {
      title: "مبلغ کل قابل پرداخت بیمه‌نامه",
      dataIndex: "PayableAmount",
      key: "PayableAmount",
      width: 220,
      render: value => value != null ? `${strings.currencyFormat(value)} ریال` : '-',
    },
    // {
    //   title: "شناسه وضعیت",
    //   dataIndex: "StatusId",
    //   key: "StatusId",
    //   width: 120,
    //   render: value => value != null ? strings.getFarsiNum(String(value)) : '-',
    // },
    {
      title: "وضعیت پرداخت قسط",
      dataIndex: "StatusTitle",
      key: "StatusTitle",
      width: 180,
    },
    {
      title: "تاریخ سررسید",
      dataIndex: "DueDate",
      key: "DueDate",
      width: 150,
      render: value => value ? strings.getFarsiNum(moment(value).format('jYYYY/jMM/jDD')) : '-',
    },
    // {
    //   title: "تاریخ دریافت",
    //   dataIndex: "RecieveDate",
    //   key: "RecieveDate",
    //   width: 150,
    //   render: value => value ? strings.getFarsiNum(moment(value).format('jYYYY/jMM/jDD')) : '-',
    // },
    // {
    //   title: "تاریخ ایجاد",
    //   dataIndex: "CreationTime",
    //   key: "CreationTime",
    //   width: 160,
    //   render: value => value ? strings.getFarsiNum(moment(value).format('jYYYY/jMM/jDD')) : '-',
    // },
    {
      title: "تاریخ پرداخت",
      dataIndex: "PaymentDate",
      key: "PaymentDate",
      width: 120,
      render: value => value ? strings.getFarsiNum(moment(value).format('jYYYY/jMM/jDD')) : '-',
    },
    {
      title: "تاریخ خرید",
      dataIndex: "BuyDate",
      key: "BuyDate",
      width: 150,
      render: value => value ? strings.getFarsiNum(moment(value).format('jYYYY/jMM/jDD')) : '-',
    },
    // {
    //   title: "شناسه تسویه",
    //   dataIndex: "SettlementReferenceId",
    //   key: "SettlementReferenceId",
    //   width: 140,
    // },
    {
      title: "تعداد کل اقساط کاربر",
      key: "TotalInstallmentCount",
      width: 180,
      render: (_, record) => {
        const key = record.ApplicantUsername || String(record.ApplicantUserId || record.Id || '');
        return strings.getFarsiNum(totalsByUser[key]?.count ?? 0);
      }
    },
    {
      title: "مجموع مبلغ اقساط کاربر",
      key: "TotalInstallmentAmount",
      width: 180,
      render: (_, record) => {
        const key = record.ApplicantUsername || String(record.ApplicantUserId || record.Id || '');
        const total = totalsByUser[key]?.amount ?? 0;
        return `${strings.getFarsiNum(strings.currencyFormat(total))} ریال`;
      }
    },
  ];

  return (
    <div className="sales-table">
      <Table
        className="custom-table"
        size="small"
        bordered
        columns={columns}
        dataSource={dataSource.map((item, index) => ({ ...item, key: item.Id ?? index }))}
        rowKey="Id"
         
        loading={loading}
        pagination={{
          current: (currentFilter.pageIndex ?? 0) + 1,
          pageSize: currentFilter.pageSize || 10,
          total: totalCount,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          showTotal: total => `نمایش ${strings.getFarsiNum(String(total))} مورد`,
          onChange: (page, pageSize) => {
          reports.getInstallmentInfo({
            param: {
              ...currentFilter,
              pageIndex: page - 1,
              pageSize,
            }
          });
        }
        }}
        scroll={{ x: 1800 }}
      />
    </div>
  );
}
